<template>
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="card mb-3">
        <div
          class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0"
        ></div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="addItem">
            <div class="row g-3 align-items-center">
              <div class="col-md-12">
                <label for="description" class="form-label">Description</label>
                <input
                  type="text"
                  v-model="nitem.description"
                  name="description"
                  id="description"
                  class="form-control"
                  v-validate="{ required: true }"
                />
                <span class="inputError">{{ errors.first("description") }}</span>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn-primary mt-4"
              :disabled="loading"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from "../../../jwt.interceptor";

export default {
  name: "ValueCreate",
  data() {
    return {
      nitem: {
        description: "",
      },
      loading: false,
    };
  },
  methods: {
    async addItem() {
      const validForm = await this.isFormValid();
      if (validForm) {
        this.loading = true;
        jwtInterceptor
          .post(this.$store.getters.getUrl + "/PashaValues", this.nitem)
          .then(() => {
            this.$toast.success("Added", {
              position: "top-right",
            });
            this.loading = false;
            this.$router.back();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.title, {
              position: "top-right",
            });
            this.loading = false;
          });
      } else {
        this.$toast.error(
          "Cells are not filled correctly. Check the boxes again!",
          {
            position: "top-right",
          },
        );
        this.loading = false;
      }
    },

    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}
</style>
